import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Services = () => {
  const { t } = useLanguage();

  return (
    <div className="pt-24 pb-16 container-custom px-4">
      <div className="text-center max-w-2xl mx-auto mb-12">
        <h1 className="text-3xl sm:text-4xl font-display font-bold text-night mb-4">{t('services.title')}</h1>
        <p className="text-gray-600 text-lg">{t('services.subtitle')}</p>
      </div>
      <div className="bg-slate rounded-2xl p-12 text-center"><p className="text-gray-500">Full services page coming soon...</p></div>
    </div>
  );
};

export default Services;
